import React from 'react';

const Pay = () => {
    return (
        <div>
            <h2>Payment system coming soon!</h2>
        </div>
    );
};

export default Pay;